export const listMessages = `
   query listMessages($filter: MessagesFilterInput, $limit: Int, $nextToken: String) {
       listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              messageId
              from
              fromText
              fromHtml
              to
              toText
              toHtml
              subject
              date
              parsedPath
              parsedObjectKey
              htmlPath
              htmlObjectKey
              textPath
              textObjectKey
              textAsHtmlPath
              textAsHtmlObjectKey
              attachments {
                  filename
              }
              aliasId
              tagIds
              tags {
                    items {
                      id
                      name
                  }
              }
              status
              inReplyTo
              createdByUsername
              managedByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getMessage = `
   query getMessage($id:ID!) {
       getMessage(id:$id) {
         id
         messageId
         from
         fromText
         fromHtml
         to
         toText
         toHtml
         subject
         date,
         parsedPath
         parsedObjectKey
         htmlPath
         htmlObjectKey
         textPath
         textObjectKey
         textAsHtmlPath
         textAsHtmlObjectKey
         attachments {
          filename
         }
         aliasId
         tagIds
         tags {
             items {
                  id
                  name
             }
         }
         status
         inReplyTo
         createdByUsername
         managedByUsername
         created
         updated
       } 
}`;


// FNP-1532: the message BODY, read through the API.
//
// Replaces the browser downloading the S3 object itself with Amplify Storage.
// The prefix-based layout the old path relied on was an Amplify convention, never
// an authorization boundary (FNP-877), and after the EMAIL OU split the browser
// cannot reach the bucket at all — it lives in another account now.
//
// `contentType` says WHICH artifact the server served (text / parsed / html).
// Callers that need plain text must branch on it rather than assume.
export const getMessageBody = `
   query getMessageBody($id:ID!) {
       getMessageBody(id:$id) {
         messageId
         textBody
         htmlBody
         truncated
         contentType
       }
}`;

// FNP-1532: a short-lived download URL for ONE attachment.
//
// Selected by ARRAY INDEX into the message's own `attachments`. Not by key (the
// server resolves that from the stored record — a client-supplied key would let
// a caller have any object signed) and not by filename (they are not unique
// within a message; see FNP-1534).
//
// Mint ON CLICK. Do not call this while rendering a list: one render would
// become N signatures.
export const getAttachmentUrl = `
   query getAttachmentUrl($messageId:ID!, $index:Int!) {
       getAttachmentUrl(messageId:$messageId, index:$index) {
         filename
         url
         expiresAt
       }
}`;
